<div class="content-heading">
  <div class="header-Container">
    <h3>Reporte de Certificacion Piezas por Envase</h3>
    <small>Reporte Web</small>
  </div>
</div>

<div class="container-fluid">
  <div class="card card-default shadow-sm border-0">
    <div class="card-body">
      
      <div class="row">
        <div class="col-lg-4 col-md-6 mb-3">
          <label>Organizaci&oacute;n</label>
          <aph-custom-select
            [items]="organizacionList"
            bindLabel="UnitDescription"
            bindValue="UnitId"
            type="default"
            placeholder="-- Seleccione --"
            [selectedValue]="organizationSelected"
            (returnValue)="organizationSelected = $event; getRegion()">
          </aph-custom-select>
        </div>

        <div class="col-lg-4 col-md-6 mb-3">
          <label>Regi&oacute;n</label>
          <aph-custom-select
            [items]="region"
            bindLabel="UnitDescription"
            bindValue="UnitId"
            type="default"
            placeholder="TODOS"
            [selectedValue]="regionSelected"
            (returnValue)="regionSelected = $event; getNodes()">
          </aph-custom-select>
        </div>

        <div class="col-lg-4 col-md-12 mb-3">
          <label>Nodo Origen</label>
          <aph-custom-select
            [items]="nodesUser"
            bindLabel="UnitDescription"
            bindValue="UnitId"
            type="default"
            placeholder="-- Búsqueda / Todos --"
            [selectedValue]="OriginNode.UnitId"
            (returnValue)="onNodeChange($event)">
          </aph-custom-select>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-lg-6 col-md-8 mb-3">
          <aph-custom-date-picker 
            [singleMode]="false" 
            labelInicio="Fecha inicial"
            labelFin="Fecha final"
            [maxDate]="today"
            mode="date"
            [IsDisabledAll]="downloading"
            (startDateChange)="minDate = $event"
            (endDateChange)="maxDate = $event"
            (onValidationStatus)="esValidoRango = $event">
          </aph-custom-date-picker>
        </div>
      </div>

      <hr class="my-4">

      <div class="row">
        <div class="col-12">
          <aph-custom-buttons 
            preset="excel" 
            [label]="downloading ? 'Descargando...' : 'Descargar reporte'" 
            [loading]="downloading"
            [disabled]="downloading || !esValidoRango"
            (btnClick)="download()">
          </aph-custom-buttons>
        </div>
      </div>

    </div>
  </div>
</div>